import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface LoadingSectionProps {
  onComplete: () => void;
}
const loadingTexts = ['Analizando tus respuestas...', 'Calculando tu nivel...', 'Preparando tu resultado...'];
export const LoadingSection: React.FC<LoadingSectionProps> = ({
  onComplete
}) => {
  const [textIndex, setTextIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex(prev => {
        if (prev < loadingTexts.length - 1) return prev + 1;
        return prev;
      });
    }, 1000);
    const timeout = setTimeout(() => {
      onComplete();
    }, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onComplete]);
  return <div className="min-h-screen bg-gradient-to-b from-lavender to-white flex flex-col items-center justify-center px-6" data-id="element-68">
      <motion.div animate={{
      rotate: 360
    }} transition={{
      repeat: Infinity,
      duration: 1.5,
      ease: 'linear'
    }} className="w-16 h-16 border-4 border-lavender border-t-brand-red rounded-full mb-8" data-id="element-69" />

      <div className="h-8 relative w-full max-w-xs text-center" data-id="element-70">
        <AnimatePresence mode="wait" data-id="element-71">
          <motion.p key={textIndex} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} className="text-xl font-semibold text-dark-blue absolute w-full" data-id="element-72">
            {loadingTexts[textIndex]}
          </motion.p>
        </AnimatePresence>
      </div>
    </div>;
};